module.exports = __webpack_public_path__ + "img/partner@2x.1eca967.webp";